
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowDown } from 'lucide-react';

const RecruitmentHero = () => {
  const scrollToJobs = () => {
    document.getElementById('job-offers')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative bg-gradient-to-br from-fabre-green via-fabre-darkgreen to-fabre-gray text-white py-20">
      <div className="absolute inset-0 bg-black/20"></div>
      
      <div className="relative container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6">
            Rejoignez notre équipe
          </h1>
          <p className="text-xl md:text-2xl mb-8 opacity-90">
            Construisons ensemble un avenir plus durable
          </p>
          <p className="text-lg mb-8 max-w-2xl mx-auto">
            Groupe Fabre Environnement recrute des talents passionnés par l'environnement 
            et désireux de contribuer à la transition écologique.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={scrollToJobs}
              size="lg"
              className="bg-white text-fabre-green hover:bg-gray-100"
            >
              Voir nos offres
              <ArrowDown className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              size="lg"
              className="bg-fabre-green text-white hover:bg-fabre-darkgreen border-fabre-green"
              onClick={() => document.getElementById('application-form')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Candidature spontanée
            </Button>
          </div>
        </div>
      </div>

      {/* Vague décorative */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg
          className="relative block w-full h-[50px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 100"
          preserveAspectRatio="none"
        >
          <path
            fill="#F9FAFB"
            fillOpacity="1"
            d="M0,32L80,42.7C160,53,320,75,480,74.7C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,100L1360,100C1280,100,1120,100,960,100C800,100,640,100,480,100C320,100,160,100,80,100L0,100Z"
          ></path>
        </svg>
      </div>
    </section>
  );
};

export default RecruitmentHero;
